/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    header: 'สรุปภาพรวม',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    items: [
      {
        url: "/",
        name: "Dashboard",
        slug: "dashboard",
        icon: "HomeIcon",
      },
    ]
  },
  {
    header: 'Management',
    icon: 'PackageIcon',
    i18n: 'Apps',
    items: [
      /*{
        url: '/management/employee',
        name: 'พนักงาน',
        icon: 'UserIcon',
        slug: 'app-employee-list',
        i18n: 'Employee',
      },*/
      {
        url: '/management/user',
        name: 'ข้อมูลลูกค้า',
        icon: 'UserIcon',
        slug: 'app-user-list',
        i18n: 'Users',
      },
     
      {
        url: '/management/user2',
        name: 'หาลูกค้า',
        icon: 'SmileIcon',
        slug: 'app-deposit-list',
        i18n: 'Deposit',
      },
      // {
      //   url: '/management/withdraw',
      //   name: 'แจ้งถอน',
      //   icon: 'FrownIcon',
      //   slug: 'app-deposit-list',
      //   i18n: 'Withdraw',
      //   tagColor: 'danger',
      // },
      // {
      //   url: '/management/statement',
      //   name: 'บันทึกรายการ',
      //   icon: 'DollarSignIcon',
      //   slug: 'app-statement-list',
      //   i18n: 'Statement',
      //   tagColor: 'danger',
      // },
      // {
      //   url: '/management/slip',
      //   name: 'แจ้งสลิป',
      //   icon: 'FileTextIcon',
      //   slug: 'app-slip-list',
      //   i18n: 'Slip',
      //   tagColor: 'danger',
      // },
      // {
      //   url: '/management/master',
      //   name: 'เซียน',
      //   icon: 'UserIcon',
      //   slug: 'app-master-list',
      //   i18n: 'Master',
      // },
      // {
      //   url: null,
      //   name: 'โปรโมชั่น',
      //   icon: 'SunIcon',
      //   slug: 'app-promotion',
      //   i18n: 'Promotion',
      //   submenu: [
      //     {
      //       url: '/management/promotion',
      //       name: 'โปรโมชั่นทั่วไป',
      //       slug: 'app-promotion2',
      //       i18n: 'promotion'
      //     },
      //     {
      //       url: '/management/cashback',
      //       name: 'เครดิตเงินคืน',
      //       slug: 'cashback',
      //       i18n: 'cashback'
      //     },
      //     {
      //       url: '/management/partner',
      //       name: 'พันธมิตร',
      //       slug: 'partner',
      //       i18n: 'partner'
      //     },
      //   ]
      // },
      // {
      //   url: '/management/agent',
      //   name: 'Agents',
      //   icon: 'UserIcon',
      //   slug: 'app-agent-list',
      //   i18n: 'Agents',
      // },
      // {
      //   url: '/management/anoucement',
      //   name: 'ประกาศ',
      //   icon: 'BellIcon',
      //   slug: 'app-anoucement-list',
      //   i18n: 'Anoucement',
      // },
      {
        url: null,
        name: 'รายงาน',
        icon: 'FileTextIcon',
        slug: 'app-report',
        i18n: 'Report',
        submenu: [
          {
            url: '/management/report-user',
            name: 'รายงานลูกค้า',
            slug: 'app-report-user',
            i18n: 'Report',
          },
          {
            url: '/management/report-deposit',
            name: 'รายงานการฝาก',
            slug: 'report-deposit',
            i18n: 'report-deposit'
          },
          {
            url: '/management/report-withdraw',
            name: 'รายงานการถอน',
            slug: 'report-withdraw',
            i18n: 'report-withdraw'
          },
          // {
          //   url: '/management/report-setcredit',
          //   name: 'รายงานการปรับเครดิต',
          //   slug: 'report-setcredit',
          //   i18n: 'report-setcredit'
          // },
          {
            url: '/management/report-register',
            name: 'รายงานการสมัครสมาชิก',
            slug: 'report-register',
            i18n: 'report-register'
          },
          {
            url: '/management/return-user',
            name: 'รายงานเครดิตเงินคืน',
            icon: 'RotateCwIcon',
            slug: 'app-return-user',
            i18n: 'Report',
          },
          {
            url: '/management/report-partner',
            name: 'รายงานพันธมิตร',
            icon: 'UsersIcon',
            slug: 'app-partner',
            i18n: 'Partner',
          },
          {
            url: '/management/report-continue',
            name: 'รายงานฝากต่อเนื่อง',
            icon: 'BarChartIcon',
            slug: 'app-continue',
            i18n: 'continue',
          },
          {
            url: '/management/report-bonus',
            name: 'Bonus',
            icon: 'BarChartIcon',
            slug: 'app-bonus',
            i18n: 'bonus',
          },
        ]
      },
      // {
      //   url: '/management/redeem-user',
      //   name: 'Redeemed',
      //   icon: 'GiftIcon',
      //   slug: 'app-redeemed',
      //   i18n: 'Report',
      // },
      // {
      //   url: null,
      //   name: 'Spin',
      //   icon: 'CompassIcon',
      //   slug: 'app-spin',
      //   i18n: 'Spin',
      //   submenu: [
      //     {
      //       url: '/management/spin',
      //       name: 'Report',
      //       slug: 'spin',
      //       i18n: 'spin'
      //     },
      //     {
      //       url: '/management/spin-setting',
      //       name: 'Setting',
      //       slug: 'spin-setting',
      //       i18n: 'spin-setting'
      //     },
      //   ]
      // },
      // {
      //   url: '/management/spin',
      //   name: 'Spin',
      //   icon: 'CompassIcon',
      //   slug: 'app-spin',
      //   i18n: 'Spin',
      // },
      // {
      //   url: '/management/roulet',
      //   name: 'Roulet',
      //   icon: 'CrosshairIcon',
      //   slug: 'app-roulet',
      //   i18n: 'Roulet',
      // },
      // {
      //   url: null,
      //   name: 'Roulet',
      //   icon: 'CrosshairIcon',
      //   slug: 'app-roulet',
      //   i18n: 'Roulet',
      //   submenu: [
      //     {
      //       url: '/management/roulet',
      //       name: 'Report',
      //       slug: 'roulet',
      //       i18n: 'roulet'
      //     },
      //     {
      //       url: '/management/roulet-setting',
      //       name: 'Setting',
      //       slug: 'roulet-setting',
      //       i18n: 'roulet-setting'
      //     },
      //   ]
      // },
      // {
      //   url: '/management/huay',
      //   name: 'หวย',
      //   icon: 'ApertureIcon',
      //   slug: 'app-huay',
      //   i18n: 'Huay',
      // },
      // {
      //   url: '/management/banner',
      //   name: 'Banner',
      //   icon: 'HeartIcon',
      //   slug: 'app-banner',
      //   i18n: 'Banner',
      // },
      // {
      //   url: '/management/bank',
      //   name: 'บัญชีธนาคาร',
      //   icon: 'MonitorIcon',
      //   slug: 'app-bank',
      //   i18n: 'Bank',
      // },
      // {
      //   url: '/management/site',
      //   name: 'Site',
      //   icon: 'TvIcon',
      //   slug: 'app-site-list',
      //   i18n: 'site',
      // },
      // {
      //   url: '/management/admin',
      //   name: 'แอดมินใจดี',
      //   icon: 'HeartIcon',
      //   slug: 'app-admin',
      //   i18n: 'Report',
      // },
      // {
      //   url: '/management/myadmin',
      //   name: 'MyAdmin',
      //   icon: 'UserIcon',
      //   slug: 'app-admin',
      //   i18n: 'MyAdmin',
      // },
      // {
      //   url: '/management/line',
      //   name: 'Line&SMS',
      //   icon: 'ApertureIcon',
      //   slug: 'app-line',
      //   i18n: 'Line',
      // },
      // {
      //   url: '/management/pushbullet',
      //   name: 'PushBullet',
      //   icon: 'UserIcon',
      //   slug: 'app-admin',
      //   i18n: 'PushBullet',
      // },
      /*{
        url: '/management/message',
        name: 'ส่งข้อความหาลูกค้า',
        icon: 'MailIcon',
        slug: 'app-message-list',
        i18n: 'Message',
      },*/
    ]
  },
]
